import { FC,useState, useEffect,  useMemo  } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
//import { Link } from '@react-navigation/native';
//import { Link } from 'react-router-dom';
import {  useLocation, useHistory,Link } from 'react-router-dom';
import moment from "moment";
import $ from 'jquery';


const CompanyOpenJobs: FC = () => {
      const intl = useIntl();
      const ITEMS_PER_PAGE = 10;

     // const companyId='79';
     const location = useLocation();
     const queryParams = new URLSearchParams(location.search);
     const companyId = queryParams.get('companyId');



      const [companyUsers, setCompanyUsers] = useState([]);
      const [jobApplicationsList, setJobApplicationsLIst] = useState([]);
      const [availableJobsList, setAvailableJobsList] = useState<any[]>([]);
      const [searchText, setsearchText] = useState();
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [search, setSearch] = useState("");
      const [sorting, setSorting] = useState({ field: "", order: "" });
      const [users, setUsers] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);



      const Pagesize=10;
      const siteId = '2';

      function validateCheck() {
        //alert("test");
      }

      /*
      function getExpireyDate(startdate){
        if(startdate == ""){
            return "";
        }
        var daten = new DateObject(startdate);
        var daten1 = daten.add(45, "d").format("D-MMM-YY");
        return daten1;
     }

      */
      useEffect(() => {
        validateCheck();
        getCurrent(companyId,'published','',ITEMS_PER_PAGE,'1','postedDate','desc');
      }, []);


      const handlePageChange2 = (offset:any,triggerevent:any) => {
        // alert(offset);
        getCurrent(companyId,'active','',ITEMS_PER_PAGE,offset,'postedDate','desc');
      };

      function getCurrent(companyId:any,status:any,title:any,ITEMS_PER_PAGE:any,pageNumber:any,sortBy:any,sortDir:any){
        //    alert(pageNumber);
            var title:any = '';
            var sortByInput = sortBy;//"postedDate";
            var sorDirInput = sortDir;//"desc";
            status = 'published';

            services.getCompanyJobExpiredCurrent(companyId,status,title,ITEMS_PER_PAGE,pageNumber,sortByInput,sorDirInput,siteId).then((res) =>
            {
                setTotalItems(res.data.totalElements);
                settotalPages(Math.ceil(res.data.totalElements / ITEMS_PER_PAGE));
                setCurrentPage(pageNumber);
                setAvailableJobsList(res.data.content);

            });
        }






      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Company Job Applications'})}</PageTitle>
          <h3 className="mb-7">Open Jobs</h3>
          <div className={`card`}>

     {/* begin::Body */}
     <div className='card-body py-3'>
       {/* begin::Table container */}
       <div className='table-responsive'>
       {/*<table className=''>
            <thead>
              <tr className='fw-bolder text-muted pb-3 '>
                <th  style={{minWidth:"450px"}}><input type="text" id="search_input" name="search_input" className="form-control" placeholder="" /> </th>
                <th className='min-w-140px'> <button type="button" onClick={searchList} className="btn btn-primary" style={{maxWidth: "135px"}}> Search </button></th>
              </tr>
            </thead>
            </table>
            */}

         {/* begin::Table */}
         <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
           {/* begin::Table head */}
           <thead>
             <tr className='fw-bolder text-muted'>

               <th className='min-w-120px'>Posted On</th>
               <th className='min-w-120px'>Title</th>
               <th className='min-w-120px'>Status</th>
               <th className='min-w-100px text-end'>Actions</th>
             </tr>
           </thead>
           {/* end::Table head */}
           {/* begin::Table body */}
           <tbody>

           {
	          availableJobsList.map((data, index) => (

             <tr>

               <td>

              <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/editjob?job_id='+data.jobId+`&companyIdget=`+companyId+`&tab=5`}><div>{data.jobTitle}</div>
              <div>{/*<strong>Applied on:</strong> */}<span className="dt-highlt">{(data.createdDate=='' || data.createdDate==null) ? '--' : moment(data.createdDate).utcOffset('-0400').format("MM/DD/YYYY, HH:mm:ss")}</span></div>
              </Link>

               </td>
               <td>
                <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/editjob?job_id='+data.jobId+`&companyIdget=`+companyId+`&tab=5`}> <div>{(data.jobTitle=='' || data.jobTitle==null) ? '--' : data.jobTitle}</div></Link>
                </td>
                <td>
                <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/editjob?job_id='+data.jobId+`&companyIdget=`+companyId+`&tab=5`}>
                <div>Published</div>
                </Link></td>



               <td className='text-end'>
                 <Link className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1' to={'/editjob?job_id='+data.jobId+`&companyIdget=`+companyId+`&tab=5`}>
                 <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                 </Link>

               </td>
             </tr>
              ))}
           </tbody>
           {/* end::Table body */}
         </table>

         <Pagination

               total={totalItems}
               itemsPerPage={ITEMS_PER_PAGE}
               currentPage={currentPage}
               onPageChange={handlePageChange2}

               />

         {/* end::Table */}
       </div>
       {/* end::Table container */}
     </div>
     {/* begin::Body */}
   </div>


        </>
      )
    }
export {CompanyOpenJobs}